import { CleaningStatus } from "./cleaningInfo"

/**
 *
 * cleaningレコード以外の関連データは含まれないため
 * あえて、SimpleCleaningという型名にしている
 */
export interface SimpleCleaning {
    id: string
    status: CleaningStatus
    /**
     *
     * 管理コストを最小限にしたので、
     * 使わないフィールドは記述していない
     *
     */
}

/**
 *
 * 清掃を清掃実績とみなすかどうか
 * 主に清掃実績ページでの利用想定をしている
 */
const isAchieved = (c: SimpleCleaning) => c.status === "reported"

/**
 *
 * 清掃のうち、清掃実績とするものを抽出する
 */
export const extractAchievedCleanings = (cleanings: SimpleCleaning[]) =>
    cleanings.filter(isAchieved)
